export enum ContentTypeEnum {
    TextEditor = 'content-blocks.text-editor',
    TitleMediumTextAndRightImage = 'content-blocks.title-medium-text-and-right-image',
}